import { render, staticRenderFns } from "./examModel.vue?vue&type=template&id=225b5ebb&scoped=true"
import script from "./examModel.vue?vue&type=script&lang=js"
export * from "./examModel.vue?vue&type=script&lang=js"
import style0 from "./examModel.vue?vue&type=style&index=0&id=225b5ebb&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "225b5ebb",
  null
  
)

export default component.exports